const context = {
    ActiveSubscriptions: 'Use this card on all active subscriptions',
    AddBillingAddress: "Add Billing Address",
    AddNew: 'Add New',
    AddPaymentMethod: 'Add Payment Method',
    AddShippingAddress: 'Add Shipping Address',
    Address: 'Address',
    Applied: 'Applied',
    Apply: 'Apply',
    ApplyUpdates: 'Apply Updates',
    BillingAddress: "Billing Address",
    Cancel: 'Cancel',
    CardHolderInformation: 'Card Holder Information',
    CardHolderInfo: "Card Holder Information",
    CardHolderInputLabel: "Name on Card",
    CardHolderInputError: "Name on Card is required",
    ContinueShoppingLink: {
        Text: "Continue Shopping",
        Url: "/shop"
    },
    City: 'City',
    Discounts: 'Discounts',
    EditExistingAddress: 'Edit Existing Address',
    EditShippingAddress: 'Edit Shipping Address',
    Edit: "Edit",
    Free: 'Free',
    Items: "Items",
    LoadingAddresses: "Shipping Addresses Loading...",
    LoadingMethods: "Shipping Methods Loading...",
    LoadingSummary: '{0} Loading...',
    Next: 'Next',
    NewAddress: 'New Address',
    OrderSummary: "Order Summary",
    PaymentMethod: "Payment Method",
    PlaceOrder: 'PlaceOrder',
    PromoApplied: 'Promo Applied',
    PromoCode: 'Promo Code',
    PromoCodeRequired: 'A promo code is required',
    PromoCodeInvalid: 'Invalid promo code',
    RemovePromoSrText: 'Remove Promo Code',
    RequiredToken: '*',
    ReviewOrder: "Review Order",
    SameAsShipping: "Same as Shipping",
    SavePayment: 'Save Payment',
    Select: 'Select',
    Shipping: 'Estimated Shipping',
    ShippingAddress: 'Shipping Address',
    ShippingMethod: 'Shipping Method',
    State: 'State',
    Subtotal: 'Subtotal',
    Tax: 'Estimated Tax',
    Total: 'Estimated Total',
    UpsellMessage: "Your are only {0} away from free shipping!",
    ValidationMessage: "{0} is required",
    Zip: 'Zip',
    AmexIcon: {
        Alt: 'American Express Card'
    },
    DiscoverIcon: {
        Alt: 'Discover Card'
    },
    MastercardIcon: {
        Alt: 'Mastercard Card'
    },
    VisaIcon: {
        Alt: 'Visa Card'
    }
}

export {
    context
};
